import OlCore from '../OlCore';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import PointModule from '../Layer/PointModule';
import { Feature, Overlay } from 'ol';
import Style from 'ol/style/Style';
import { Circle, Fill, Icon } from 'ol/style.js';
import IcoSiteMarker from '../../assets/images/map/ico-site-marker.svg';
import IcoSiteMarkerActive from '../../assets/images/map/ico-site-marker-active.svg';
import Select from 'ol/interaction/Select';
import { click } from 'ol/events/condition';
class ObjectSite extends PointModule {
  private siteLayer: VectorLayer<VectorSource>;
  private siteSource!: VectorSource;
  private siteFeatures: Feature[] = [];
  private clickEvent!: Select;
  private overlay: Overlay = new Overlay({
    element: document.getElementById('siteOverlay') as HTMLDivElement,
    positioning: 'bottom-center',
    offset: [0, -34],
  });
  constructor(core: OlCore) {
    super(core);

    this.siteLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'siteLayer',
      },
      visible: true,
      zIndex: 4,
    });
    this.setLayers([this.siteLayer]);
    this.core.mapInstance.addOverlay(this.overlay);
  }

  public draw(data) {
    this.siteFeatures = this.createSiteFeatures(data);
    this.siteSource = this.createSource(this.siteFeatures);
    this.siteLayer.setSource(this.siteSource);
    this.siteLayer.setStyle(() => {
      return [
        new Style({
          image: new Icon({
            src: IcoSiteMarker,
            size: [24, 26],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            anchor: [12, 26],
          }),
        }),
      ];
    });
  }

  public moveSite(data) {
    const currentFeature = this.siteFeatures.find((feature) => feature.getId() === data.siteId);
    this.core.mapInstance.getView().fit((currentFeature?.getGeometry() as any).getExtent(), { duration: 500, maxZoom: 20 });
    const coordinates = (currentFeature?.getGeometry() as any).getCoordinates();
    this.overlay.setPosition(coordinates);
    this.clickEvent.getFeatures().push(currentFeature!);
  }

  public select(callback) {
    this.clickEvent = new Select({
      layers: [this.siteLayer],
      condition: click,
      style: () => {
        return [
          new Style({
            image: new Icon({
              src: IcoSiteMarkerActive,
              size: [50, 52],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels',
              anchor: [25, 39],
            }),
          }),
        ];
      },
    });
    this.core.mapInstance.addInteraction(this.clickEvent);
    this.clickEvent.on('select', (e) => {
      if (e.selected.length) {
        const selectedFeature = e.selected[0];
        callback(selectedFeature.getProperties().properties.siteId);
      } else {
        this.init(callback);
      }
    });
  }

  public init(callback) {
    callback('');
    this.clickEvent.getFeatures().clear();
    this.overlay.setPosition(undefined);
  }
}

export default ObjectSite;
